<script lang="ts" setup>
import LogoIconSvg from '@/assets/images/logo-icon.svg';
import LogoTextSvg from '@/assets/images/logo-text.svg';
import GetStartedBtn from '../GetStartedBtn.vue';
</script>

<template>
  <section class="py-8 md:py-12 lg:py-20">
    <div class="mx-auto min-h-96 max-w-6xl px-6 text-center">
      <div class="fade-in">
        <LogoIconSvg
          filled
          :font-controlled="false"
          class="mx-auto mb-[18px] h-20 w-20 md:h-32 md:w-32"
        />
        <LogoTextSvg
          color="#050529"
          :font-controlled="false"
          class="mx-auto mb-[22px] w-[160px] md:w-[236px]"
        />
        <div class="mx-auto mb-10">
          <h1
            class="text-2xl leading-snug font-bold text-[#050529] md:text-3xl lg:text-[32px] lg:leading-[32px]"
          >
            Bring your old documents
          </h1>
          <h2
            class="mt-0.5 text-2xl leading-snug font-bold text-[#050529] md:text-3xl lg:text-[32px] lg:leading-[32px]"
          >
            up to date—instantly.
          </h2>
        </div>

        <GetStartedBtn />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.fade-in {
  animation: fadeIn 0.35s ease both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
